import { render, staticRenderFns } from "./AdminWebsiteTextPage.vue?vue&type=template&id=14c558fe&"
import script from "./AdminWebsiteTextPage.vue?vue&type=script&lang=js&"
export * from "./AdminWebsiteTextPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports